'use client'

import React, { PropsWithChildren } from 'react'

interface Props {
  size?: 'medium' | 'large'
  fullWidth?: boolean
  color?: 'primary' | 'secondary'
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  disabled?: boolean
}

export const Button = ({
  children,
  size = 'medium',
  fullWidth = false,
  color = 'primary',
  onClick,
  disabled = false,
  type = 'button',
}: PropsWithChildren<Props>) => {
  const isSizeMedium = size === 'medium'
  const isColorPrimary = color === 'primary'

  return (
    <button
      type={type}
      className={`flex justify-center items-center rounded-[4px] text-white cursor-pointer h-fit
    ${isSizeMedium ? 'px-[12px] py-[8px]' : 'px-[16px] py-[16px]'} 
    ${isSizeMedium ? 'text-body3_strong' : 'text-body1_strong'}
    ${fullWidth ? 'w-full' : 'w-fit'}
    ${
      isColorPrimary
        ? 'bg-[#8981ee] hover:bg-[#514fb6] disabled:bg-[#8e8e93] disabled:text-[#d8d6e5] active:bg-[#28245b]'
        : 'bg-[#393D45] hover:bg-[#2E3239] disabled:bg-[#8E8E93] disabled:text-[#D8D6E5] active:bg-[#23262D]'
    }
    `}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
